import { AssetSignaling } from "./AssetSignaling";
import { AssetServer } from "./AssetServer";
import { PeerAssetProvider } from "./PeerAssetProvider";
import { TrafficMeter } from "./TrafficMeter";
export class P2PSession {
    #context;
    #signaling;
    #provider;
    #server;
    #trafficMeter;
    #terminated = false;
    constructor(context, roomName, serverUrl) {
        this.#context = context;
        this.#trafficMeter = new TrafficMeter();
        const socket = context.createSocket(`${serverUrl}/signaling`);
        this.#signaling = new AssetSignaling(socket, `assets:${roomName}`);
        this.#provider = new PeerAssetProvider(this.#signaling, context.localPeerId, this.#trafficMeter);
        this.#server = new AssetServer(this.#signaling, context.localPeerId, context.assetReader, this.#trafficMeter);
        context.chainedSampleProvider.attachPeer({
            fetch: (uuid, progress) => this.#provider.fetchSample(uuid, progress)
        });
        context.chainedSoundfontProvider.attachPeer({
            fetch: (uuid, progress) => this.#provider.fetchSoundfont(uuid, progress)
        });
    }
    get signaling() { return this.#signaling; }
    get trafficMeter() { return this.#trafficMeter; }
    terminate() {
        if (this.#terminated) {
            return;
        }
        this.#terminated = true;
        this.#context.chainedSampleProvider.detachPeer();
        this.#context.chainedSoundfontProvider.detachPeer();
        this.#provider.terminate();
        this.#server.terminate();
        this.#signaling.terminate();
        this.#trafficMeter.terminate();
    }
}
